import React, { useEffect } from 'react';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import './refundpolicy.css';
import Upperbox from '../components/Upperbox';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';

const Refundpolicy = () => {
    // ✅ Scroll to top when component loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <NavBar />

            <div className="refund-policy-container">
                <h1 className="refund-policy-main-title">Refund Policy</h1>

                <div className="refund-policy-section">
                    <div className="refund-policy-content">
                        <p>• All amounts listed in the Tax Summary are shown in USD.</p>
                        <p>• Once payment is completed and the client has downloaded their documents, no refunds will be issued under any circumstances.</p>
                        <p>• However, based on the efforts and services rendered up to that point, a partial refund may be considered.</p>
                        <p>• Fees paid to Litax are non-refundable once you've confirmed the filing of your tax return, and the return has been successfully submitted.</p>
                        <p>• If you're eligible for a referral reward, it will be credited to your account after April 25, or you may apply it as a discount during payment.</p>
                        <p>• Please note that Tax Filing Fees do not cover FBAR filing fees unless specifically requested.</p>
                    </div>
                </div>
            </div>

            <Whatsapp />
            <ScrollTop />
            <Footer />
        </div>
    );
};

export default Refundpolicy;
